<div [ngClass]="to?.className === 'xilo-input' ? 'form-row' : 'input-form-row'">
  <div [ngClass]="to?.className === 'xilo-input' ? 'form-item' : 'input-form-item'">
    <label *ngIf="to.label">
      {{ to.label }}
      <span *ngIf="to?.required" class="required-indicator">*</span>

      <span *ngIf="to.showToolTip" mat-icon-button aria-label="Tooltip icon" [matTooltip]="to.toolTipText" matTooltipPosition="above">
        <mat-icon>help_outline</mat-icon>
      </span>
    </label>
    <div class="mat-datepicker" *ngIf="isInputType('date')">
      <mat-form-field class="mat-datepicker-form-field font-inter-regular" [floatLabel]="'never'" [ngClass]="changeInputCSS(formControl.invalid, formControl.touched, to.className)">
        <input
        [id]="field.key"
        matInput
        #dateInput
        [matDatepicker]="picker"
        [max]="maxDate"
        (keydown.enter)="picker.open()"
        (dateChange)="dateChange($event)"
        [formControl]="formControl"
        xiloDatePlaceholder
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="picker"
        [disableRipple]="true"
        tabindex="-1"
        [attr.aria-hidden]="true"
      />
      <mat-datepicker
        #picker
        [restoreFocus]="false"
        [calendarHeaderComponent]="datePickerHeader"
        (closed)="onDatepickerClosed()"
      ></mat-datepicker>
      </mat-form-field>
    </div>
    <input
      *ngIf="isInputType('prefix')"
      [ngClass]="changeInputCSS(formControl.invalid, formControl.touched, to.className)"
      [class]="to.className || 'xilo-input'"
      [type]="'text'"
      [prefix]="to?.prefix"
      [mask]="returnMask()"
      [formControl]="formControl"
      [formlyAttributes]="field"
      (blur)="updateMetadata($event)"
    />
    <input
      *ngIf="isInputType('suffix')"
      [ngClass]="changeInputCSS(formControl.invalid, formControl.touched, to.className)"
      [class]="to.className || 'xilo-input'"
      [type]="'text'"
      [suffix]="to?.suffix"
      [mask]="returnMask()"
      [formControl]="formControl"
      [formlyAttributes]="field"
      (blur)="updateMetadata($event)"
    />
    <input
      *ngIf="isInputType('input')"
      [class]="to.className || 'xilo-input'"
      [ngClass]="changeInputCSS(formControl.invalid, formControl.touched, to.className)"
      [type]="toType() || 'text'"
      [formControl]="formControl"
      [formlyAttributes]="field"
      (blur)="handleBlur($event)"
    />
    <div *ngIf="formControl.invalid && formControl.touched && isInputType('input') && toType() === 'email'" class="error-message">
      <div *ngIf="formControl.hasError('required')">This field is required.</div>
      <div *ngIf="formControl.hasError('email')">Please enter a valid email.</div>
      <div *ngIf="formControl.hasError('noTLD')">The email must include a top-level domain (e.g., .com, .net).</div>
    </div>
    <div *ngIf="formControl.touched && formControl.hasError('futureDate')" class="error-message">Please select a date before today.</div>
  </div>
</div>
